<template>
  <div>
    <b-row no-gutters class="page-header">
      <b-col v-html="pageTitle" />
    </b-row>
    <div class="arrow-down"></div>
  </div>
</template>

<script>
import { contentComputed } from '@state/helpers';

export default {
  name: "PageHeader",

  props: {
    page: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: 'no description'
    }
  },

  computed: {
    ...contentComputed,

    pageTitle() {
      // eslint-disable-next-line no-prototype-builtins
      return this.options.hasOwnProperty(this.page)
        ? this.options[this.page].description
        : this.description;
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@design';

  .page-header {
    text-transform: uppercase;
    padding: 25px;
    font-weight: bold;
    color: $color-container-text;
    text-align: center;
    background-color: $color-container-bg;
  }

  .arrow-down {
    width: 0;
    height: 0;
    margin: -1px auto;
    border-top: 20px solid $color-container-bg;
    border-right: 20px solid transparent;
    border-left: 20px solid transparent;
  }
</style>
